var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-auditor" },
    [
      _vm.auditor && _vm.auditor.fileFlow
        ? [
            _vm._l(_vm.auditor.fileFlow, function(item, i) {
              return [
                _c(
                  "div",
                  { key: "fileFlow_title_" + i, staticClass: "title" },
                  [
                    _vm._v(
                      "\n        文件审批" +
                        _vm._s(_vm.auditor.fileFlow.length > 1 ? i + 1 : "") +
                        "\n        "
                    ),
                    _c("span", { staticClass: "isOrder" }, [
                      _vm._v(_vm._s(item.orderNum ? "顺序审批" : "会审"))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { key: "fileFlow_0" + i, staticClass: "item" },
                  [
                    item.selfFlag
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: item.initiateName + "(我)",
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "user" }, [
                                _c("span", {
                                  staticClass: "el-icon-user-solid"
                                })
                              ])
                            ]
                          )
                        ]
                      : [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: item.initiateName,
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "user" }, [
                                _c("span", {
                                  staticClass: "el-icon-user-solid"
                                })
                              ])
                            ]
                          )
                        ],
                    _c("div", { staticClass: "desc" }, [
                      _c("p", [
                        _c("span", { staticClass: "user-tilte-color" }, [
                          _vm._v("申请人：")
                        ]),
                        _c("span", [_vm._v(_vm._s(item.createTime))])
                      ]),
                      _c("p", { staticClass: "userName" }, [
                        _c("span", [_vm._v(_vm._s(item.initiateName))])
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "chap",
                        class: _vm.status(item.signStatus)
                      },
                      [
                        _c("div", { staticClass: "chap-box" }, [
                          _vm._v(_vm._s(_vm.statusText(item.signStatus)))
                        ])
                      ]
                    )
                  ],
                  2
                ),
                _c("div", { key: "fileFlow_" + i, staticClass: "content" }, [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(
                      "\n          共" +
                        _vm._s(item.instPartyList.length) +
                        "方\n          "
                    ),
                    _c(
                      "span",
                      {
                        style: {
                          color: _vm.colorStatus,
                          float: "right",
                          marginRight: "20px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.allStatus) + "\n            ")]
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "obj-box" },
                    _vm._l(item.instPartyList, function(v, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "obj" },
                        [
                          v.selfFlag
                            ? [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: v.userName + "(我)",
                                      placement: "bottom"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "user" }, [
                                      _c("span", {
                                        staticClass: "el-icon-user-solid"
                                      })
                                    ])
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: v.userName,
                                      placement: "bottom"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "user" }, [
                                      _c("span", {
                                        staticClass: "el-icon-user-solid"
                                      })
                                    ])
                                  ]
                                )
                              ],
                          _c("div", { staticClass: "obj-other" }, [
                            _c("p", { staticClass: "userName" }, [
                              _vm._v(_vm._s(v.userName))
                            ]),
                            v.flowStatus === 1
                              ? _c(
                                  "div",
                                  { staticClass: "status text-color-green" },
                                  [
                                    _vm._v(
                                      "\n                已同意\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            v.flowStatus === 2
                              ? _c(
                                  "div",
                                  { staticClass: "status text-color-red" },
                                  [
                                    _vm._v(
                                      "\n                已驳回\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            v.flowStatus === 0
                              ? _c("div", { staticClass: "status" }, [
                                  _vm._v("未审批")
                                ])
                              : _vm._e(),
                            v.flowTime
                              ? _c("div", { staticClass: "time" }, [
                                  _vm._v(_vm._s(v.flowTime))
                                ])
                              : _vm._e(),
                            v.refuseReason
                              ? _c("div", { staticClass: "reason" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [_vm._v("审批意见:")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(v.refuseReason) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v("\n              \n            "),
                          v.flowStatus === 0
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "approver-bth-sty",
                                  attrs: {
                                    plain: "",
                                    type: "primary",
                                    size: "small",
                                    disabled:
                                      index > 0 &&
                                      _vm.indexFlowStatus(
                                        item.instPartyList
                                      ) !== index &&
                                      item.orderNum
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.urgeForTrial(v)
                                    }
                                  }
                                },
                                [_vm._v("催审")]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    0
                  )
                ])
              ]
            })
          ]
        : _vm._e(),
      _vm.IsShow
        ? _c("sign-approve", { attrs: { signAuditor: _vm.auditor.sealFlow } })
        : _vm._e(),
      !_vm.auditor.fileFlow.length && !_vm.auditor.sealFlow.length
        ? [
            _c("no-data", {
              attrs: {
                slot: "empty",
                text: "当前审批流程需要在钉钉微应用中查看，SAAS不支持查看"
              },
              slot: "empty"
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-683a3e32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683a3e32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/auditDetail/new.vue
// module id = rpkH
// module chunks = 12 13 14 17 26 32